/************************************************************************************

* [COMPONENT]: L-HEADER

*************************************************************************************/

class LTAHeader extends HTMLElement {
	constructor() {
		super()
	}

	connectedCallback() {
		// Elements
		this.cartLinkEls = this.querySelectorAll('cart-link')

		// Events
		this.handleCartLinkClick()
		this.handleSearchDrawerOpen()

		document.addEventListener('l:cart:updated', (event) => {
			const cart = event.detail.cartData

			this.cartLinkEls.forEach((cartLinkEl) => {
				const cartCountEl = cartLinkEl.querySelector('items-count')

				cartCountEl.innerHTML = cart.item_count
			})
		})
	}

	handleSearchDrawerOpen() {
		const searchDrawerEl = document.querySelector('[data-trigger-search-drawer]')

		if (searchDrawerEl) {
			searchDrawerEl.addEventListener('click', (event) => {
				event.preventDefault()
			})
		}
	}

	handleCartLinkClick(event) {
		// this.cartLinkEls.forEach((cartLinkEl) => {
		// 	cartLinkEl.addEventListener('click', (event) => {
		// 		event.preventDefault()

		// 		window.Rebuy?.SmartCart?.show?.()
		// 	})
		// })
	}
}

customElements.define('l-header', LTAHeader)

/************************************************************************************

* [COMPONENT]: L-HEADER-DRAWER-MOBILE

*************************************************************************************/

class LTAHeaderMobile extends HTMLElement {
	constructor() {
		super()
	}

	connectedCallback() {
		// Elements
		this.toggleMenuBtnEl = document.getElementById('mobileToggleHamburger')
		this.drawerInnerEl = this.querySelector('[data-inner]')
		this.closeBtnEls = this.querySelectorAll('[data-header-close]')

		// Data
		this.modalName = 'header'

		// Events
		if (this.toggleMenuBtnEl) this.setupEvents()
	}

	setupEvents() {
		this.toggleMenuBtnEl.addEventListener('click', () => {
			const isOpen = this.classList.contains('is-active')

			isOpen ? this.close() : this.open()
		})

		this.closeBtnEls.forEach((closeBtnEl) => {
			closeBtnEl.addEventListener('click', () => {
				this.close()
			})
		})
	}

	open() {
		this.toggleMenuBtnEl.classList.add('is-active')

		l_setupVariablesBeforeOpenModal()
		l_lockBodyScroll(this.modalName)

		this.classList.remove('l-hidden')

		requestAnimationFrame(() => {
			this.classList.add('is-active')
		})

		document.addEventListener('click', this.handleOnClickOutSide.bind(this))
	}

	close() {
		this.toggleMenuBtnEl.classList.remove('is-active')

		l_unLockBodyScroll(this.modalName)

		this.classList.remove('is-active')

		l_debounce(() => {
			this.classList.add('l-hidden')
		}, 400)()
		document.removeEventListener('click', this.handleOnClickOutSide.bind(this))
	}

	handleOnClickOutSide(event) {
		if (!this.drawerInnerEl.contains(event.target) && !this.toggleMenuBtnEl.contains(event.target)) {
			this.close()
		}
	}
}

customElements.define('l-header-drawer-mobile', LTAHeaderMobile)

/************************************************************************************

* [COMPONENT]: L-HEADER-DRAWER-DESKTOP

*************************************************************************************/

class LTAHeaderDesktop extends HTMLElement {
	constructor() {
		super()
	}

	connectedCallback() {
		// Elements
		this.level1ListLinkEl = document.getElementById('headerLv1Links')

		if (!this.level1ListLinkEl) return

		this.menuDrawerEls = this.querySelectorAll('[id^="headerMenuDrawerLv2-"], [id^="headerMenuDrawerLv3-"]')
		this.level1LinkEls = this.level1ListLinkEl.querySelectorAll('[data-lv1-link]')
		this.level2LinkEls = this.querySelectorAll('[data-lv2-link]')
		this.singleLinkEls = this.querySelectorAll('[data-single-link]')

		// Data
		this.modalName = 'headerDesktop'

		// Events (add 1s debounce to prevent flickering)
		l_debounce(() => {
			this.setupLv1MouseOverEvents()
			this.handleOnClickOutSide()
		}, 1000)()
	}

	setupLv1MouseOverEvents() {
		// Setup mouseover events for level 1 links
		this.level1LinkEls.forEach((level1LinkEl) => {
			level1LinkEl.addEventListener('click', (e) => {
				const menuHandle = level1LinkEl.dataset.lv1Link
				if(menuHandle) {
					e.preventDefault();
				}
				// Update header variables
				l_setupVariablesBeforeOpenModal()
				l_lockBodyScroll(this.modalName)

				// Update link
				this.level1LinkEls.forEach((level1LinkEl) => {
					level1LinkEl.classList.toggle('is-active', level1LinkEl.dataset.lv1Link === menuHandle)
				})

				// Update drawer menus
				this.menuDrawerEls.forEach((menuDrawerEl) => {
					menuDrawerEl.classList.toggle('is-active', menuDrawerEl.id === `headerMenuDrawerLv2-${menuHandle}`)
				})
				document.dispatchEvent(new Event('open:header-menu-drawer'));
				this.classList.add('is-active')
			})
		})

		// Setup mouseout events for level 2 links
		this.level2LinkEls.forEach((level2LinkEl) => {
			level2LinkEl.addEventListener('mouseenter', (e) => {
				const menuHandle = level2LinkEl.dataset.lv2Link
				if(menuHandle) {
					e.preventDefault();
				}
				document.dispatchEvent(new CustomEvent('change:actived-v2-link',{
					detail: {
						handle: menuHandle
					}
				}));
				// Update drawer menus level 3
				this.menuDrawerEls.forEach((menuDrawerEl) => {
					if (menuDrawerEl.id.startsWith('headerMenuDrawerLv3-')) {
						menuDrawerEl.classList.toggle('is-active', menuDrawerEl.id === `headerMenuDrawerLv3-${menuHandle}`)
					}
				})
			})
		})

		// Remove menu drawer level 3
		this.singleLinkEls.forEach((singleLinkEl) => {
			singleLinkEl.addEventListener('mouseenter', () => {
				this.menuDrawerEls.forEach((el) => {
					if (el.id.startsWith('headerMenuDrawerLv3-')) {
						el.classList.remove('is-active')
					}
				})
			})
		})
	}

	handleOnMouseOut() {
		this.level1ListLinkEl.addEventListener('mouseleave', () => {
			this.level1LinkEls.forEach((el) => el.classList.remove('is-active'))
			this.menuDrawerEls.forEach((el) => el.classList.remove('is-active'))
		})
	}

	handleOnClickOutSide() {
		document.addEventListener('click', (event) => {
			const isClickOutside = ![this.level1ListLinkEl, ...this.menuDrawerEls].some((el) => el.contains(event.target))

			if (isClickOutside) {
				document.dispatchEvent(new Event('close:header-menu-drawer'));
				this.classList.remove('is-active')
				this.level1LinkEls.forEach((el) => el.classList.remove('is-active'))
				this.menuDrawerEls.forEach((el) => el.classList.remove('is-active'))
				l_unLockBodyScroll(this.modalName)
			}
		})
	}
}

customElements.define('l-header-drawer-desktop', LTAHeaderDesktop)

/************************************************************************************

* [COMPONENT]: L-HEADER-SEARCH-DRAWER

*************************************************************************************/
class LTAHeaderSearchDrawer extends LTADrawer {
	constructor() {
		super()
	}

	connectedCallback() {
		super.connectedCallback()

		// Elements
		this.formEl = this.querySelector('form')
		this.suggestionsEl = this.querySelector('[data-suggestions]')
		this.searchInputEl = this.querySelector('[data-search-input]')
		this.searchBtnEl = this.querySelector('[data-search-btn]')
		this.searchResultsEl = this.querySelector('[data-search-results]')
		this.clearBtnEl = this.querySelector('[data-search-clear]')
		this.loadingEl = this.querySelector('[data-search-loading]')

		// Data
		this.cachedResults = {}

		// Events
		const debouncedOnChange = l_debounce((event) => {
			this.handleSearchTermChange(event)
		}, 300)

		this.formEl.addEventListener('submit', debouncedOnChange.bind(this))
		this.searchInputEl.addEventListener('input', debouncedOnChange.bind(this))
		this.clearBtnEl.addEventListener('click', this.handleClearSearch.bind(this))

		// Run functions
		this.handleSearchTermsClickEvent()
		this.handleOnSearchPage()
	}

	handleSearchTermChange() {
		const queryKey = this.searchInputEl.value.replace(' ', '-').toLowerCase()

		// Setup loading state
		this.enableLoadingState()

		if (this.cachedResults[queryKey]) {
			this.renderSearchResults(this.cachedResults[queryKey])
			return
		}

		// Fetch predictive search results
		const searchURL = `${window.theme.routes.predictive_search_url}?q=${encodeURIComponent(queryKey)}&section_id=a-ajax-header-predictive-search`

		fetch(searchURL)
			.then((response) => {
				return response.text()
			})
			.then((htmlText) => {
				const resultsMarkup = l_getSectionDOM(htmlText, '#shopify-section-a-ajax-header-predictive-search')

				// Cache results
				this.cachedResults[queryKey] = resultsMarkup

				// Render results
				this.renderSearchResults(resultsMarkup)
			})
			.catch((error) => {
				console.error(error)

				this.disableLoadingState()
			})
	}

	handleSearchTermsClickEvent() {
		this.suggestionTermEls = this.querySelectorAll('[data-term-suggestion]')

		this.suggestionTermEls.forEach((suggestionTermEl) => {
			suggestionTermEl.addEventListener('click', (event) => {
				event.preventDefault()

				const searchTerm = suggestionTermEl.dataset.termSuggestion

				this.searchInputEl.value = searchTerm
				this.searchInputEl.focus()

				this.formEl.dispatchEvent(new Event('submit'))
			})
		})
	}

	renderSearchResults(resultsMarkup) {
		this.searchResultsEl.innerHTML = resultsMarkup.innerHTML

		// Remove loading state
		this.disableLoadingState()
	}

	handleClearSearch() {
		this.searchInputEl.value = ''
		this.searchInputEl.focus()

		this.searchResultsEl.innerHTML = ''

		this.loadingEl.classList.add('l-hidden')
		this.searchResultsEl.classList.remove('is-loading')
		this.searchResultsEl.classList.add('is-no-search')
	}

	handleOnSearchPage() {
		const templateName = this.dataset.templateName

		const isSearchPageWithoutQuery = () => {
			const currentURL = window.location.pathname
			const isSearchPageWithoutQuery = currentURL == this.dataset.searchUrl && window.location.search == ''

			return isSearchPageWithoutQuery
		}

		// Check if the current page is the search page
		if (templateName == 'search') {
			if (isSearchPageWithoutQuery()) this.drawer_open()
		}

		// Setup popstate event listener
		window.addEventListener('popstate', () => {
			if (isSearchPageWithoutQuery()) this.drawer_open()
		})
	}

	enableLoadingState() {
		this.loadingEl.classList.remove('l-hidden')
		this.searchResultsEl.classList.add('is-loading')
		this.searchBtnEl.classList.add('is-loading')
	}

	disableLoadingState() {
		this.loadingEl.classList.add('l-hidden')
		this.searchResultsEl.classList.remove('is-loading')
		this.searchBtnEl.classList.remove('is-loading')
		this.searchResultsEl.classList.remove('is-no-search')
	}

	drawer_open() {
		super.drawer_open()

		this.searchInputEl.focus()
	}
}

customElements.define('l-header-search-drawer', LTAHeaderSearchDrawer)

